/* =============================================================
   KLARHEIT 2027 — Auto-Gift (7-Tage-Challenge "Gratis dabei")
   + Stift-Restposten Zeile (Caran d'Ache 849) im Warenkorb.

   Teil 1 (Gift): Liegt ein Host-Produkt (AIR / 8) im Warenkorb, wird
   die Challenge GIFT-Variante (€0 "Geschenk") mit Menge 1 automatisch
   hinzugefügt. Entfernt, sobald kein Host-Produkt mehr drin ist.
   Die Gift-Variante ist mit €0 bepreist (kein Rabatt), damit die
   AIR/8-Staffelpreise nie durch eine BXGY-Vorbedingung blockiert werden.

   Teil 2 (Stift): Liegt ein Host-Produkt im Warenkorb und noch kein
   Stift, erscheint als letzte Zeile ein Angebot mit Farbwahl. Ein Klick
   legt die Variante in den Warenkorb. Rein additiv, kein Liquid-Eingriff:
   Markup und Styles werden hier injiziert, damit die Zeile jedes
   Re-Rendering des Drawers übersteht.
   ============================================================= */
(function () {
  var GIFT_VARIANT = 53211590492426; // KLARHEIT 7 TAGE CHALLENGE — "Geschenk" (€0)
  var ELIGIBLE_HANDLES = ['klarheit-air', 'klarheit8'];
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var busy = false;
  var timer = null;

  function isGift(item) {
    /* Nur die Challenge-Variante zaehlt hier als Geschenk. Andere Gratis-Zugaben
       (Becher, Sticker bei DEEP FOCUS) tragen auch "_gratis", gehoeren aber nicht
       zu dieser Regel und duerfen von ihr weder entfernt noch gekuerzt werden. */
    return item.variant_id === GIFT_VARIANT;
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) { return r.json(); });
  }

  function renderSections(sections) {
    if (!sections) return;
    var drawerHTML = sections['cart-drawer'];
    if (drawerHTML) {
      var parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
      var fresh = parsed.querySelector('#CartDrawer');
      var current = document.querySelector('#CartDrawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    var bubbleHTML = sections['cart-icon-bubble'];
    if (bubbleHTML) {
      var bubble = document.getElementById('cart-icon-bubble');
      var parsedB = new DOMParser().parseFromString(bubbleHTML, 'text/html');
      var freshB = parsedB.querySelector('.shopify-section') || parsedB.body.firstElementChild;
      if (bubble && freshB) bubble.innerHTML = freshB.innerHTML;
    }
  }

  function sync() {
    if (busy) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasEligible = false, gift = null;
        (cart.items || []).forEach(function (it) {
          if (ELIGIBLE_HANDLES.indexOf(it.handle) >= 0) hasEligible = true;
          if (isGift(it)) gift = it;
        });

        var op = null;
        if (hasEligible && !gift) {
          op = postJSON('/cart/add.js', {
            items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _gratis: 'true' } }],
            sections: SECTIONS, sections_url: window.location.pathname,
          });
        } else if (!hasEligible && gift) {
          op = postJSON('/cart/change.js', {
            id: String(gift.key), quantity: 0,
            sections: SECTIONS, sections_url: window.location.pathname,
          });
        } else if (gift && gift.quantity > 1) {
          op = postJSON('/cart/change.js', {
            id: String(gift.key), quantity: 1,
            sections: SECTIONS, sections_url: window.location.pathname,
          });
        }

        if (!op) { addon.refresh(); return null; }
        busy = true;
        return op
          .then(function (res) { renderSections(res && res.sections); })
          .catch(function () {})
          .then(function () { busy = false; addon.refresh(); });
      })
      .catch(function () {});
  }

  function scheduleSync() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; if (!busy) sync(); }, 150);
  }

  /* ===========================================================
     Stift-Restposten Zeile
     =========================================================== */
  var addon = (function () {
    var PEN_HANDLE = 'caran-dache-kugelschreiber-849';
    // Stift-Zeile im Warenkorb ist aus (07.10.2026, ruhiger Warenkorb).
    // Wieder an: ['klarheit-air', 'klarheit8', 'deepfocus']
    var HOST_HANDLES = [];
    var ROW_ID = 'k27-pen-addon';
    var STYLE_ID = 'k27-pen-addon-css';

    // Farbpunkte je Variante. Fällt auf neutral zurück, wenn eine
    // Variante hinzukommt, die hier nicht steht.
    var SWATCH = {
      'BLACK CODE': '#111111',
      'GOLDBAR': '#C9A227',
      'BRUT ROSE': '#C98F86',
      'FLUO ROSA': '#FF4FA3',
      'FLUO ORANGE': '#FF6B1A',
      'FLUO GELB': '#E8DB00',
    };

    var product = null;
    var loading = false;
    var writing = false;
    var observer = null;

    var CSS = [
      '.k27-drawer #' + ROW_ID + '{order:3;border:1px solid var(--rule,#E6E4DD);background:#fff;',
      'border-radius:12px;padding:12px;margin-top:10px;}',
      '#' + ROW_ID + ' .pa-top{display:flex;align-items:center;gap:10px;}',
      '#' + ROW_ID + ' .pa-th{width:48px;height:48px;flex:0 0 48px;border-radius:9px;overflow:hidden;',
      'border:1px solid #ECEAE4;background:#F7F8F9;}',
      '#' + ROW_ID + ' .pa-th img{width:100%;height:100%;object-fit:cover;display:block;}',
      '#' + ROW_ID + ' .pa-txt{min-width:0;flex:1 1 auto;}',
      '#' + ROW_ID + ' .pa-name{font-size:13.5px;line-height:1.25;color:#0A0A0A;font-weight:500;}',
      '#' + ROW_ID + ' .pa-sub{font-size:11.5px;line-height:1.35;color:#454545;margin-top:2px;}',
      '#' + ROW_ID + ' .pa-price{text-align:right;flex:0 0 auto;font-size:13px;line-height:1.25;}',
      '#' + ROW_ID + ' .pa-was{display:block;font-size:11px;color:#6B6760;text-decoration:line-through;}',
      '#' + ROW_ID + ' .pa-now{font-weight:600;color:#0A0A0A;}',
      '#' + ROW_ID + ' .pa-opts{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px;}',
      '#' + ROW_ID + ' .pa-chip{display:inline-flex;align-items:center;gap:6px;border:1px solid #E6E4DD;',
      'background:#fff;border-radius:999px;padding:6px 11px 6px 8px;font-family:inherit;font-size:11.5px;',
      'line-height:1;color:#0A0A0A;cursor:pointer;transition:border-color .12s ease-out,background-color .12s ease-out;}',
      '#' + ROW_ID + ' .pa-chip:hover{border-color:#0A0A0A;background:#FAFAF8;}',
      '#' + ROW_ID + ' .pa-chip:focus-visible{outline:2px solid #0A0A0A;outline-offset:2px;}',
      '#' + ROW_ID + ' .pa-chip[aria-busy="true"]{opacity:.55;cursor:default;}',
      '#' + ROW_ID + ' .pa-dot{width:11px;height:11px;border-radius:50%;flex:0 0 11px;',
      'box-shadow:inset 0 0 0 1px rgba(0,0,0,.16);}',
      '#' + ROW_ID + ' .pa-note{font-size:11px;line-height:1.4;color:#454545;margin-top:9px;}',
      '@media (max-width:749px){#' + ROW_ID + ' .pa-chip{padding:12px 14px 12px 11px;font-size:12px;}}',
      '@media (prefers-reduced-motion: reduce){#' + ROW_ID + ' .pa-chip{transition:none;}}',
    ].join('');

    function injectCSS() {
      if (document.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = CSS;
      document.head.appendChild(s);
    }

    function money(cents) {
      var eur = cents / 100;
      var s = (eur % 1 === 0) ? String(eur) : eur.toFixed(2).replace('.', ',');
      return s + '€';
    }

    function load() {
      if (product || loading) return Promise.resolve(product);
      loading = true;
      return fetch('/products/' + PEN_HANDLE + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { product = p; loading = false; return p; })
        .catch(function () { loading = false; return null; });
    }

    function build(variants) {
      var prices = variants.map(function (v) { return v.price; });
      var min = Math.min.apply(null, prices);
      var max = Math.max.apply(null, prices);
      var wasList = variants
        .map(function (v) { return v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0; })
        .filter(function (c) { return c > 0; });

      var nowLabel = (min === max) ? money(min) : 'ab ' + money(min);
      var wasLabel = '';
      if (wasList.length) {
        var wmin = Math.min.apply(null, wasList);
        var wmax = Math.max.apply(null, wasList);
        wasLabel = (wmin === wmax) ? money(wmin) : money(wmin) + '–' + money(wmax);
      }

      var img = product.featured_image || (product.images && product.images[0]) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var thumb = img
        ? '<img src="' + img.split('?')[0] + '?width=140" alt="" loading="lazy" width="48" height="48">'
        : '';

      var chips = variants.map(function (v) {
        var color = SWATCH[v.title] || '#C9C5BD';
        var label = v.title.replace(/^FLUO /, '').toLowerCase()
          .replace(/(^|\s)\S/g, function (m) { return m.toUpperCase(); });
        return '<button type="button" class="pa-chip" data-k27-pen-add data-variant-id="' + v.id + '"' +
          ' aria-label="' + v.title + ' für ' + money(v.price) + ' in den Warenkorb legen">' +
          '<span class="pa-dot" style="background:' + color + '"></span>' + label + '</button>';
      }).join('');

      var row = document.createElement('div');
      row.id = ROW_ID;
      row.className = 'ci-pen-addon';
      row.innerHTML =
        '<div class="pa-top">' +
          '<div class="pa-th">' + thumb + '</div>' +
          '<div class="pa-txt">' +
            '<div class="pa-name">Der Stift dazu</div>' +
            '<div class="pa-sub">Caran d’Ache 849</div>' +
          '</div>' +
          '<div class="pa-price">' +
            (wasLabel ? '<span class="pa-was">' + wasLabel + '</span>' : '') +
            '<span class="pa-now">' + nowLabel + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="pa-opts">' + chips + '</div>' +
        '<div class="pa-note">Swiss Made. Nur solange der Vorrat reicht.</div>';
      return row;
    }

    function wanted(cart) {
      var hasHost = false, hasPen = false;
      (cart.items || []).forEach(function (it) {
        if (HOST_HANDLES.indexOf(it.handle) >= 0) hasHost = true;
        if (it.handle === PEN_HANDLE) hasPen = true;
      });
      return hasHost && !hasPen;
    }

    function place() {
      var wrap = document.querySelector('#CartDrawer .drawer__cart-items-wrapper');
      var existing = document.getElementById(ROW_ID);
      if (!wrap) { if (existing) existing.remove(); return; }

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var show = wanted(cart);
          var host = document.querySelector('#CartDrawer .drawer__cart-items-wrapper');
          var row = document.getElementById(ROW_ID);
          if (!show || !host) { if (row) row.remove(); return; }
          if (row && host.contains(row)) return;
          return load().then(function (p) {
            if (!p) return;
            var avail = (p.variants || []).filter(function (v) { return v.available; });
            if (!avail.length) return;
            var host2 = document.querySelector('#CartDrawer .drawer__cart-items-wrapper');
            if (!host2 || document.getElementById(ROW_ID)) return;
            injectCSS();
            writing = true;
            host2.appendChild(build(avail));
            setTimeout(function () { writing = false; }, 0);
          });
        })
        .catch(function () {});
    }

    var placeTimer = null;
    function refresh() {
      if (writing) return;
      if (placeTimer) clearTimeout(placeTimer);
      placeTimer = setTimeout(function () { placeTimer = null; place(); }, 60);
    }

    function watch() {
      var target = document.getElementById('CartDrawer');
      if (!target || observer) return;
      observer = new MutationObserver(function () { refresh(); });
      observer.observe(target, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-k27-pen-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      postJSON('/cart/add.js', {
        items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }],
        sections: SECTIONS,
        sections_url: window.location.pathname,
      })
        .then(function (res) {
          product = null; // Bestand kann sich geändert haben
          renderSections(res && res.sections);
        })
        .catch(function () { btn.removeAttribute('aria-busy'); })
        .then(function () { refresh(); });
    });

    return { refresh: refresh, watch: watch };
  })();

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var a = arguments;
      var url = (a[0] && a[0].url) ? a[0].url : ('' + a[0]);
      var p = origFetch.apply(this, a);
      if (!busy && CART_MUTATION.test(url)) {
        p.then(function () { scheduleSync(); }).catch(function () {});
      }
      return p;
    };
  }

  function init() { addon.watch(); sync(); addon.refresh(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
